import React from 'react';
import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';

export interface Props {
    colOne: React.ReactNode;
    colTwo: React.ReactNode;
    variations?: string[];
}

export default function TwoColumnContainer(props: Props) {
    const classNames = getComponentClasses(
        'two-column-container',
        props.variations ? props.variations : []
    );

    return (
        <div className={classNames}>
            <div className="two-column-container__col-one">{props.colOne}</div>
            <div className="two-column-container__col-two">{props.colTwo}</div>
        </div>
    );
}
